// extracted by mini-css-extract-plugin
module.exports = {"collection":"collection_collection__S3MdJ","section":"collection_section__AwX1b"};